export const CUSTOM_FIELDS_TYPES = {
  CustomFieldApiService: Symbol.for('CustomFieldApiService'),
  CustomFieldRepository: Symbol.for('CustomFieldRepository'),
  CustomFieldUseCase: Symbol.for('CustomFieldUseCase'),
  CustomFieldDao: Symbol.for('CustomFieldDao'),
};
